var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 17,
    rx: 8.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.146 6.06a.916.916 0 011.294 1.294l-4.369 4.369-1.78.485.486-1.78 4.369-4.368z",
    stroke: "#515152",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 17,
    rx: 8.5,
    stroke: "#515152"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyIgcng9IjguNSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTExLjE0NTggNi4wNTk3NUMxMS4yMzA4IDUuOTc0NzYgMTEuMzMxNyA1LjkwNzM0IDExLjQ0MjcgNS44NjEzNEMxMS41NTM4IDUuODE1MzQgMTEuNjcyOCA1Ljc5MTY3IDExLjc5MyA1Ljc5MTY3QzExLjkxMzIgNS43OTE2NyAxMi4wMzIyIDUuODE1MzQgMTIuMTQzMyA1Ljg2MTM0QzEyLjI1NDMgNS45MDczNCAxMi4zNTUyIDUuOTc0NzYgMTIuNDQwMiA2LjA1OTc1QzEyLjUyNTIgNi4xNDQ3NSAxMi41OTI2IDYuMjQ1NjUgMTIuNjM4NiA2LjM1NjdDMTIuNjg0NiA2LjQ2Nzc1IDEyLjcwODMgNi41ODY3NyAxMi43MDgzIDYuNzA2OTdDMTIuNzA4MyA2LjgyNzE3IDEyLjY4NDYgNi45NDYxOSAxMi42Mzg2IDcuMDU3MjRDMTIuNTkyNiA3LjE2ODI5IDEyLjUyNTIgNy4yNjkyIDEyLjQ0MDIgNy4zNTQxOUw4LjA3MTQ4IDExLjcyMjlMNi4yOTE2MyAxMi4yMDgzTDYuNzc3MDQgMTAuNDI4NUwxMS4xNDU4IDYuMDU5NzVaIiBzdHJva2U9IiM1MTUxNTIiIHN0cm9rZS13aWR0aD0iMC44IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyIgcng9IjguNSIgc3Ryb2tlPSIjNTE1MTUyIi8+Cjwvc3ZnPgo=";
export { SvgEditNote as ReactComponent };